export default "__VITE_ASSET__xVgGQ3EK__"